<div class="pre-loader-inner">
  <div class="loader-text mb-16" *ngIf="text">{{ text }}</div>
  <ion-spinner name="crescent"></ion-spinner>
</div>
